import { useState } from "react";
import CommonModal from "./Modal/CommonModal";
import CommonModalTitle from "./Modal/CommonModalTitle";
import CargoEnquiryForm from "./ServicesFrom/CargoEnquiryForm";

export default function CargoServices() {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <div>
      <section className="pb-5 pt-0" style={{ backgroundColor: "#fff" }}>
        <div className="services-pages-banner">
          <div>
            <img
              src="/assets/images/cargo_service_banner.png"
              alt="Not found"
              className="w-100"
            />
            <img
              src="/assets/images/cargo_service_banner-mobile.webp"
              alt="Not found"
              className="w-100 service-mobile-view-banner"
            />
          </div>
          <div>
            <button
              className="btn getquoteBtn mt-5 mb-3 mx-2 text-center d-block banner-button"
              onClick={handleOpen}
            >
              <img
                src="/assets/images/arrow_right.svg"
                alt="Not found"
                height={12}
              />
              <span className="px-2 d-inline-block fw-bold p-0">
                Request A Quote
              </span>
            </button>
          </div>
        </div>
        <div className="container">
          <div className="cargo-service-info text-center mt-5">
            <h3>Our Cargo Services</h3>
            <p>
              Whether you're shipping across cities or continents, we help you
              choose the right mode. <br /> Based on what matters most to you:
              Speed or savings.
            </p>
            <img src="/assets/images/cargo-flow.png" />
          </div>

          <section className="courier-mode">
            <div className="row">
              <div className="col-md-6">
                <div className="cargo-service-box">
                  <h3>Courier Mode</h3>
                  <h6 className="mb-4">
                    Best for: Small packages, urgent shipments
                  </h6>

                  <h5>How it works:</h5>
                  <p>
                    {" "}
                    Courier Mode is ideal for quick, lightweight deliveries. We
                    partner with leading carriers like FedEx, DHL, UPS  to
                    ensure your package arrives fast, safe, and trackable—door
                    to door.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="cargo-service-box-img text-center">
                  <img src="/assets/images/courier_mode.png" alt="Not found" />
                </div>
              </div>

              <div className="col-md-6">
                <div className="cargo-service-cards">
                  <div className="row">
                    <div className="col-7">
                      <h3>Common Use Cases</h3>
                      <ul>
                        <li>
                          <p>E-commerce deliveries</p>
                        </li>
                        <li>
                          <p>Urgent documents</p>
                        </li>
                        <li>
                          <p>Lightweight personal goods</p>
                        </li>
                        <li>
                          <p>Business cash advances</p>
                        </li>
                      </ul>
                    </div>

                    <div className="col-5">
                      <div className="cargo-service-cards-img">
                        <img
                          src="/assets/images/use-cases.png"
                          alt="Not found"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="cargo-service-cards">
                  <div className="row">
                    <div className="col-7">
                      <h3>Why Choose This Mode:</h3>
                      <ul>
                        <li>
                          <p>Fastest option</p>
                        </li>
                        <li>
                          <p>Ideal for small parcels</p>
                        </li>
                        <li>
                          <p>Global reach</p>
                        </li>
                      </ul>
                    </div>

                    <div className="col-5">
                      <div className="cargo-service-cards-img">
                        <img
                          src="/assets/images/why-choose.png"
                          alt="Not found"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button className="btn getquoteBtn mt-5 mb-0" onClick={handleOpen}>
              Request a Quote
            </button>
          </section>

          <section className="land-freight">
            <div className="row">
              <div className="col-md-6">
                <div className="cargo-service-box-img text-center">
                  <img src="/assets/images/land_freight.png" alt="Not found" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="cargo-service-box">
                  <h3>Land Freight</h3>
                  <h6 className="mb-4">
                    Best for: Regionally connected countries by land
                  </h6>

                  <h5>How it works:</h5>
                  <p>
                    Land Freight offers a cost-efficient and faster option than
                    sea freight—where land access is available. We move your
                    goods across GCC countries with reliable schedules and full
                    visibility.
                  </p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="cargo-service-cards">
                  <div className="row">
                    <div className="col-7">
                      <h3>Common Routes</h3>
                      <ul>
                        <li>
                          <p>
                            UAE to Saudi Arabia, Bahrain, Kuwait, Oman, Qatar
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div className="col-5">
                      <div className="cargo-service-cards-img">
                        <img
                          src="/assets/images/use-cases.png"
                          alt="Not found"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="cargo-service-cards">
                  <div className="row">
                    <div className="col-7">
                      <h3>Why Choose This Mode:</h3>
                      <ul>
                        <li>
                          <p>Cost-effective for regional trade.</p>
                        </li>
                        <li>
                          <p>Door-to-door delivery</p>
                        </li>
                        <li>
                          <p>Suitable for medium to large cargo</p>
                        </li>
                      </ul>
                    </div>

                    <div className="col-5">
                      <div className="cargo-service-cards-img">
                        <img
                          src="/assets/images/why-choose.png"
                          alt="Not found"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button className="btn getquoteBtn mt-5 mb-0" onClick={handleOpen}>
              Request a Quote
            </button>
          </section>

          <section className="air-freight">
            <div className="row">
              <div className="col-md-6">
                <div className="cargo-service-box">
                  <h3>Air Freight</h3>
                  <h6 className="mb-4">
                    Best for: Larger shipments that need speed
                  </h6>

                  <h5>How it works:</h5>
                  <p>
                    Air Freight balances speed and cost for time-sensitive cargo
                    too large for couriers. We work with top-tier carriers
                    (Emirates, British Airways, Lufthansa) to move your goods
                    fast—whether up to port or direct to your door.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="cargo-service-box-img text-center">
                  <img src="/assets/images/air_freight.png" alt="Not found" />
                </div>
              </div>

              <div className="col-md-6">
                <div className="cargo-service-cards">
                  <div className="row">
                    <div className="col-7">
                      <h3>Perfect For</h3>
                      <ul>
                        <li>
                          <p>B2B - Commercial Shipments</p>
                        </li>
                        <li>
                          <p>Larger orders with tight deadlines </p>
                        </li>
                        <li>
                          <p>Goods that need special handling</p>
                        </li>
                      </ul>
                    </div>

                    <div className="col-5">
                      <div className="cargo-service-cards-img">
                        <img
                          src="/assets/images/use-cases.png"
                          alt="Not found"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="cargo-service-cards">
                  <div className="row">
                    <div className="col-7">
                      <h3>Why Choose This Mode:</h3>
                      <ul>
                        <li>
                          <p>Faster than sea freight</p>
                        </li>
                        <li>
                          <p>
                            More affordable than courier (for heavier goods)
                          </p>
                        </li>
                        <li>
                          <p>Global delivery.</p>
                        </li>
                      </ul>
                    </div>

                    <div className="col-5">
                      <div className="cargo-service-cards-img">
                        <img
                          src="/assets/images/why-choose.png"
                          alt="Not found"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button className="btn getquoteBtn mt-5 mb-0" onClick={handleOpen}>
              Request a Quote
            </button>
          </section>

          <section className="sea-freight">
            <div className="row">
              <div className="col-md-6">
                <div className="cargo-service-box-img text-center">
                  <img src="/assets/images/sea_freight.png" alt="Not found" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="cargo-service-box">
                  <h3>Sea Freight</h3>
                  <h6 className="mb-4">
                    Best for: Bulk shipments, oversized goods
                  </h6>

                  <h5>How it works:</h5>
                  <p>
                    Sea Freight is your go-to for high-volume, large sized, and
                    cost-sensitive deliveries. Ideal for non-urgent cargo, we
                    offer both FCL (Full Container Load) and LCL (Less than
                    Container Load) services through trusted lines like Maersk,
                    CMA-CGM, and Hapag-Lloyd.
                  </p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="cargo-service-cards">
                  <div className="row">
                    <div className="col-7">
                      <h3>Popular Use Cases</h3>
                      <ul>
                        <li>
                          <p>Business imports/exports</p>
                        </li>
                        <li>
                          <p>Home relocation containers</p>
                        </li>
                        <li>
                          <p>Large furniture and machinery</p>
                        </li>
                      </ul>
                    </div>

                    <div className="col-5">
                      <div className="cargo-service-cards-img">
                        <img
                          src="/assets/images/use-cases.png"
                          alt="Not found"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="cargo-service-cards">
                  <div className="row">
                    <div className="col-7">
                      <h3>Why Choose This Mode:</h3>
                      <ul>
                        <li>
                          <p>Most economical for large shipments</p>
                        </li>
                        <li>
                          <p>Suitable for 100kg+</p>
                        </li>
                        <li>
                          <p>Global port-to-port and port-to-door service</p>
                        </li>
                      </ul>
                    </div>

                    <div className="col-5">
                      <div className="cargo-service-cards-img">
                        <img
                          src="/assets/images/why-choose.png"
                          alt="Not found"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button className="btn getquoteBtn mt-5 mb-0" onClick={handleOpen}>
              Request a Quote
            </button>
          </section>
          
          <section className="what-to-choose">
            <h3>Not Sure What to Choose?</h3>
            <h5>Let us simplify it for you. </h5>
            <p>
              Our cargo experts will guide you on the best freight method for
              your needs—no guesswork required.
            </p>
          </section>
        </div>
      </section>

      <CommonModal open={open} onClose={handleClose} fullWidth={true}>
        <CommonModalTitle>Cargo Enquiry Form</CommonModalTitle>
        <CargoEnquiryForm handleClose={handleClose} />
      </CommonModal>
    </div>
  );
}
